import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-pre-owned-orders-change-status',
  templateUrl: './pre-owned-orders-change-status.component.html',
  styleUrls: ['./pre-owned-orders-change-status.component.scss']
})
export class PreOwnedOrdersChangeStatusComponent implements OnInit {
  changeStatusForm = this.fb.group({
    status: ['APPROVED', [Validators.required]],
    invoice: [null],
    message: [null, [Validators.required]]
  });
  constructor(
    private fb: FormBuilder,
    private _dialogRef: MatDialogRef<PreOwnedOrdersChangeStatusComponent>,
  ) { }

  ngOnInit(): void {
  }
  
  /* ---------------------------- Custom Functions ---------------------------- */
  dialogClose() {
    // this._dialogRef.close();
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this._dialogRef.close(); }, 1000);
  }
  /* --------------------------------- Getters -------------------------------- */
  get status(){
    return this.changeStatusForm.get('status');
  }
  get invoice(){
    return this.changeStatusForm.get('invoice');
  }
  get message(){
    return this.changeStatusForm.get('message');
  }
  async updateStatus(){

  }
}
